export enum PhaseOfMovement {
  OnGround_with_Warnings = 0,
  OnGround_Ready = 1,
  OnGround = 2,
  TakeOff = 3,
  Ascending = 4,
  LevelFlight = 5,
  Descending = 6,
  Landing = 7,
  Hover = 8,
  Moving = 9,
  Landed = 10,
  LandedStopped = 11,
  Stopped = 12,
  undefined = 13
}

// Helper function to get string representation of the enum
export function getPhaseOfMovementString(value: PhaseOfMovement | number): string {
  switch (value) {
    case PhaseOfMovement.OnGround_with_Warnings: return "OnGround_with_Warnings";
    case PhaseOfMovement.OnGround_Ready: return "OnGround_Ready";
    case PhaseOfMovement.OnGround: return "OnGround";
    case PhaseOfMovement.TakeOff: return "TakeOff";
    case PhaseOfMovement.Ascending: return "Ascending";
    case PhaseOfMovement.LevelFlight: return "LevelFlight";
    case PhaseOfMovement.Descending: return "Descending";
    case PhaseOfMovement.Landing: return "Landing";
    case PhaseOfMovement.Hover: return "Hover";
    case PhaseOfMovement.Moving: return "Moving";
    case PhaseOfMovement.Landed: return "Landed";
    case PhaseOfMovement.LandedStopped: return "LandedStopped";
    case PhaseOfMovement.Stopped: return "Stopped";
    case PhaseOfMovement.undefined: return "undefined";
    default: return "unknown";
  }
}
